import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaTiktok, FaCalendarAlt, FaFilePdf } from 'react-icons/fa';
import './SocialButton.css';

const SocialButtons = ({ 
  facebookUrl,
  instagramUrl,
  linkedinUrl,
  tiktokUrl,
  calendlyUrl,
  pdfUrl,
  onContactClick 
}) => {

  // Función genérica para manejar clics y evitar repetir código
  const handleSocialClick = (url, network) => {
    if (onContactClick) {
      onContactClick(network);
    }
    if (url && url !== "#") {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="social-buttons-container">
      {/* PDF Button (solo si pdfUrl existe y no es "#") */}
      {pdfUrl && pdfUrl !== "#" && (
        <button className="social-button pdf" onClick={() => handleSocialClick(pdfUrl, 'pdf')}>
          <FaFilePdf size={20} />
        </button>
      )}

      {/* Facebook Button */}
      {facebookUrl && facebookUrl !== "#" && (
        <button className="social-button facebook" onClick={() => handleSocialClick(facebookUrl, 'facebook')}>
          <FaFacebook size={20} />
        </button>
      )}

      {/* Instagram Button */}
      {instagramUrl && instagramUrl !== "#" && (
        <button className="social-button instagram" onClick={() => handleSocialClick(instagramUrl, 'instagram')}>
          <FaInstagram size={20} />
        </button>
      )}

      {/* LinkedIn Button */}
      {linkedinUrl && linkedinUrl !== "#" && (
        <button className="social-button linkedin" onClick={() => handleSocialClick(linkedinUrl, 'linkedin')}>
          <FaLinkedin size={20} />
        </button>
      )}

      {/* TikTok Button */}
      {tiktokUrl && tiktokUrl !== "#" && (
        <button className="social-button tiktok" onClick={() => handleSocialClick(tiktokUrl, 'tiktok')}>
          <FaTiktok size={20} />
        </button>
      )}

      {/* Calendly Button */}
      {calendlyUrl && calendlyUrl !== "#" && (
        <button className="social-button calendly" onClick={() => handleSocialClick(calendlyUrl, 'calendly')}>
          <FaCalendarAlt size={20} />
          <span className="calendly-text">Agendar Cita</span>
        </button>
      )}
    </div>
  );
};

export default SocialButtons;